import { getLocalAdminDetails } from '../../config/utils';

const getAdminInitialState = () => {
    const oriAdminDetails = getLocalAdminDetails();
    const states = {
        admin_details: {
            _id: oriAdminDetails && oriAdminDetails._id ? oriAdminDetails._id : null,
            nlpServiceDetails: oriAdminDetails && oriAdminDetails.nlpServiceDetails ? oriAdminDetails.nlpServiceDetails : null,
            allowedChannels: oriAdminDetails && oriAdminDetails.allowedChannels ? oriAdminDetails.allowedChannels : [],
            brandInfo: oriAdminDetails && oriAdminDetails.brandInfo ? oriAdminDetails.brandInfo : null,
            admin_id: oriAdminDetails && oriAdminDetails.admin_id ? oriAdminDetails.admin_id : null,
            token: oriAdminDetails && oriAdminDetails.token ? oriAdminDetails.token : null,
            user_info: oriAdminDetails && oriAdminDetails.user_info ? oriAdminDetails.user_info : {},
            current_state: {},
            loaders: {
                auth_loading: false,
                token_verifying: false,
                token_verified: false,
            }
        }
    };
    return states;
};

export default getAdminInitialState;



// WEBPACK FOOTER //
// ./src/data/redux/admin_details/states.js